enum LogEventEnum {
	ROUTE_VISITED_LOGGED = 'route_visited_logged',
	ROUTE_VISITED_LOGGED_OUT = 'route_visited_logged_out',
	EXTERNAL_LINK_VISITED = 'external_link_visited',
}

enum LogEventLoginEnum {
	PORTAL_LOGIN_SUCCESS = 'portal_login_success',
	PORTAL_LOGIN_INVALID_CREDENTIALS = 'portal_login_invalid_credentials',
}

enum LogEventBookingEnum {
	PORTAL_HEALTH_BOOKING_COMPLETE = 'portal_health_booking_complete',
	PORTAL_DENTAL_BOOKING_COMPLETE = 'portal_dental_booking_complete',
	PORTAL_TELE_BOOKING_COMPLETE = 'portal_tele_booking_complete',
	PORTAL_TELE_BOOKING_UNAUTHORIZED = 'A seleção desta especialidade requer autorização prévia para possibilitar\u00A0o\u00A0agendamento.',
	PORTAL_TELE_BOOKING_UNAVAILABLE = 'Horário indisponível, favor informar outro horário.',
	PORTAL_EXAM_BOOKING_COMPLETE = 'portal_exam_booking_complete',
	PORTAL_HEALTH_BOOKING_CANCEL = 'portal_health_booking_cancel',
	PORTAL_DENTAL_BOOKING_CANCEL = 'portal_dental_booking_cancel',
	PORTAL_TELE_BOOKING_CANCEL = 'portal_tele_booking_cancel',
	PORTAL_EXAM_BOOKING_CANCEL = 'portal_exam_booking_cancel',
}

enum LogEventFacialBiometricsEnum {
	REGISTER_FACIAL_BIOMETRICS_SUCCESS = 'register_facial_biometrics_success',
}

export {LogEventEnum, LogEventLoginEnum, LogEventBookingEnum, LogEventFacialBiometricsEnum};
